import { CreateOrganizationGroupDto, OrganizationGroupDto, UpdateOrganizationGroupDto } from "@dialogics/shared/dto/types"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { ModalProps } from "../../component/modal"
import { useCreateOrganizationGroupMutation, useUpdateOrganizationGroupMutation } from "./organization-group-service"

type OrganizationGroupFormProps = {
  organizationGroup?: OrganizationGroupDto
  organizationId: number
} & ModalProps

export const OrganizationGroupForm = ({ isOpen, onClose, organizationGroup, organizationId }: OrganizationGroupFormProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<CreateOrganizationGroupDto | UpdateOrganizationGroupDto>({
    defaultValues: organizationGroup,
  })
  const [createOrganizationGroup, { isLoading: isCreating }] = useCreateOrganizationGroupMutation()
  const [updateOrganizationGroup, { isLoading: isUpdating }] = useUpdateOrganizationGroupMutation()

  useEffect(() => {
    if (organizationGroup) {
      reset(organizationGroup)
    } else {
      reset({ code: "" })
    }
  }, [organizationGroup, reset])

  const onSubmit = async (data: CreateOrganizationGroupDto | UpdateOrganizationGroupDto) => {
    if (organizationGroup) {
      await updateOrganizationGroup({ id: organizationGroup.id, ...data })
    } else {
      await createOrganizationGroup({ organization_id: organizationId, ...data } as CreateOrganizationGroupDto)
    }
    onClose()
  }

  return (
    <dialog className={`modal ${isOpen ? "modal-open" : ""}`}>
      <div className="modal-box">
        <h3 className="font-bold text-lg">{organizationGroup ? "Редактировать конфигурацию" : "Создать конфигурацию"}</h3>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <fieldset className="fieldset">
            <legend className="fieldset-legend">Код</legend>
            <input
              {...register("code", { required: "Код обязателен" })}
              className={`input input-bordered w-full ${errors.code ? "input-error" : ""}`}
            />
            {errors.code && <span className="text-error text-xs">{errors.code.message}</span>}
          </fieldset>
          <div className="modal-action">
            <button type="button" className="btn" onClick={onClose} disabled={isCreating || isUpdating}>
              Отмена
            </button>
            <button type="submit" className="btn btn-primary" disabled={isCreating || isUpdating}>
              {isCreating || isUpdating ? "Сохранение..." : "Сохранить"}
            </button>
          </div>
        </form>
      </div>
    </dialog>
  )
}
